import { Text, View } from '@react-pdf/renderer';
import startCase from 'lodash/startCase';
import camelCase from 'lodash/startCase';
// eslint-disable-next-line no-restricted-imports
import { tv } from 'tailwind-variants';

import { tw } from './pdf-tw';
import { commonStyles } from './styles';

const styles = tv({
  slots: {
    row: commonStyles.body({ className: 'flex w-full flex-row gap-2 px-2' }),
  },
});

const { row } = styles();

const titleCase = (str: string) => startCase(camelCase(str));

type ColDef = {
  label?: string;
  alignText?: 'left' | 'right' | 'center';
  width: number;
};

export function PdfTable<Keys extends string>({
  columns,
  rows,
}: {
  columns: { [K in Keys]: ColDef };
  rows: Record<Keys, string | string[]>[];
}) {
  return (
    <View style={tw('w-full flex flex-col gap-2 mb-2')}>
      <View style={tw(row())}>
        {Object.entries(columns).map((e) => {
          const [key, c] = e as [Keys, ColDef];
          const alignmentClass = `text-${c.alignText ?? 'left'}`;
          const widthClass = `w-[${c.width}%]`;
          return (
            <View key={key} style={tw(`${widthClass} font-semibold`)}>
              <Text style={tw(alignmentClass)}>
                {c.label ?? titleCase(key)}
              </Text>
            </View>
          );
        })}
      </View>
      {rows.map((r, i) => {
        return (
          <View style={tw(row())} key={i}>
            {Object.entries(columns).map((e) => {
              const [key, c] = e as [Keys, ColDef];
              const alignmentClass = `text-${c.alignText ?? 'left'}`;
              const widthClass = `w-[${c.width}%]`;
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              const colValue = r[key]!;
              return (
                <View key={i} style={tw(widthClass)}>
                  <Text
                    style={tw(`text-body-sm ${alignmentClass} leading-tight`)}
                  >
                    {colValue}
                  </Text>
                </View>
              );
            })}
          </View>
        );
      })}
    </View>
  );
}
